export default __webpack_public_path__ + "images/3711d932711bc5a9d3750535ae38be2a-x-yellow.svg";